import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hamburger",
  "use": "icon-hamburger-usage",
  "viewBox": "0 0 27 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 18\" id=\"icon-hamburger\"><path stroke=\"#222\" stroke-linecap=\"round\" stroke-width=\"3\" d=\"M2 2h23M2 9.106h23M2 16h23\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol